import React, { useState, useEffect } from 'react';
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { ModalComponent } from '@app/components';
import { IMyProfile } from '@app/models';
import { useTypedTranslation, useUrlParams } from '@app/hooks';
import { getModalSwitch } from '@app/store/actions';
import { getDialogTitleManageMfa } from '@app/helpers';
import { ManageMfaSteps } from '@app/enums';
import { ActiveMethodManageMfa } from '@app/models';
import { ManageMfaTokenDialog } from '../dialogs/manageMfaToken.dialog';

interface IProps {
    myProfile: IMyProfile;
    modalSwitchState: boolean;
}

const openMfaTokenDialog = (dispatch: Dispatch, onClickCb: Function) => () => {
    dispatch(getModalSwitch(true));
    onClickCb();
};

const computeShowMfaChangeButtons = (myProfile: IMyProfile) => {
    if (myProfile !== undefined && myProfile.person !== undefined) {
        const mfaKeyPresent = myProfile.person.attributes.mfaKeyPresent;
        const u2fEnabledPresent = myProfile.person.attributes.u2fEnabledPresent;

        return mfaKeyPresent || u2fEnabledPresent;
    }

    return false;
};

export const MfaChangeButtons: React.SFC<IProps> = ({ myProfile, modalSwitchState }) => {
    const { translation } = useTypedTranslation();
    const dispatch = useDispatch();
    const { registermfa: registermfa } = useUrlParams<{ registermfa: boolean }>();

    const [activeMethod, setActiveMethod] = useState<ActiveMethodManageMfa>('');
    const [stepManageMfa, setStepManageMfa] = useState<ManageMfaSteps>(ManageMfaSteps.chooseMethod);
    const [isMfaConfigured, setIsMfaConfigured] = useState<boolean>(false);
    const [isModalActive, setIsModalActive] = useState<boolean>(false);

    useEffect(() => {
        if (registermfa && registermfa !== undefined && !computeShowMfaChangeButtons(myProfile)) {
            dispatch(getModalSwitch(true));
            setIsMfaConfigured(false);
            setIsModalActive(true);
        }
    }, [registermfa, myProfile]);

    const onClose = () => {
        setIsModalActive(false);
        dispatch(getModalSwitch(false));
    };

    return (
        <>
            {isModalActive && (
                <ModalComponent
                    form={
                        <ManageMfaTokenDialog
                            activeMethod={activeMethod}
                            setActiveMethod={setActiveMethod}
                            isMfaConfigured={isMfaConfigured}
                            stepManageMfa={stepManageMfa}
                            setStepManageMfa={setStepManageMfa}
                            setIsModalActive={setIsModalActive}
                        />
                    }
                    modalSwitcherCallback={onClose}
                    headerTitle={getDialogTitleManageMfa(stepManageMfa, activeMethod, translation)}
                    modalSwitcher={modalSwitchState}
                />
            )}
            {computeShowMfaChangeButtons(myProfile) ? (
                <span className='detailPage__list--row'>
                    <button
                        className='detailPage__link'
                        onClick={openMfaTokenDialog(dispatch, () => {
                            setIsMfaConfigured(true);
                            setIsModalActive(true);
                        })}
                        id='manageMfaLink'
                    >
                        {translation('MANAGE_MFA_TOKEN_LINK')}
                    </button>
                </span>
            ) : (
                    <span className='detailPage__list--row'>
                        <button
                            className='detailPage__link'
                            onClick={openMfaTokenDialog(dispatch, () => {
                                setIsMfaConfigured(false);
                                setIsModalActive(true);
                            })}
                            id='setupMfaLink'
                        >
                            {translation('SETUP_MFA_TOKEN_LINK')}
                        </button>
                    </span>
                )}
        </>
    );
};
